export enum MimeTypeName {
    pdf = 'application/pdf',
    jpg = 'image/jpg',
    jpeg = 'image/jpeg',
    png = 'image/png',
    bmp = 'image/bmp',
    gif = 'image/gif',
    txt = 'text/plain',
    rtf = 'application/rtf',
    xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls = 'application/vnd.ms-excel',
    docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    doc = 'application/msword',
    xml = 'text/xml',
    default = 'application/octet-stream',
};

export const MimeTypeLabel: Record<MimeTypeName, string> = {
    [MimeTypeName.pdf]: "pdf",
    [MimeTypeName.jpg]: "jpg",
    [MimeTypeName.jpeg]: "jpeg",
    [MimeTypeName.png]: "png",
    [MimeTypeName.bmp]: "bmp",
    [MimeTypeName.gif]: "gif",
    [MimeTypeName.txt]: "txt",
    [MimeTypeName.rtf]: "rtf",
    [MimeTypeName.xlsx]: "xlsx",
    [MimeTypeName.xls]: "xls",
    [MimeTypeName.docx]: "docx",
    [MimeTypeName.doc]: "doc",
    [MimeTypeName.xml]: "xml",
    [MimeTypeName.default]: "",
};